import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _ls from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _hm from './_hm';
import * as _ht from './_ht';

import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  tgt: '役割割当',
};

let $_42z = {
  _42rz: {},
  _421s: []
} as _ht.dz;
let $_10z = {
  _10rz: {},
} as _ht.dz;

let $_10rs = [] as _ht.ls;
let $_41rs = [] as _ht.ls;

let $_10r_key = -1;

const $schz = {
  word: '',
};

const $schAsync = async (
  frcUdt: () => void
) => {
  $_10rs = await _cmFTH.loadLsAsync2({
    tgt: '_10r.load_10zLsAsync',
    ... $schz,
  });
  if (frcUdt) frcUdt();
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _sPz = _ls.usePz({
    steps: [0],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dw/w3`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topStlz: a(`dw/w4`),
        topClds: [
          _cr.c(T, {
            sPz: _sPz,
          })
        ],
        cttStlz: a(`dw/w3`),
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(IptC.N, {
          cz: {
            bEdit: true,
            iptType: 't',
            vle: $schz.word,
            onChg: (_s: _ht.s) => {
              $schz.word = _s;
            },
          },
          iptPtyz: a(`ipt/ユーザ名、メールアドレス ipc/lt3`),
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();
  const _gUserz = _gv.useUserz();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 0
    ) {
      _hm.ectSrlAsync([
        async () => {
          $_41rs = await _cmFTH.loadLsAsync2({
            tgt: '_41r.load_41zLsAsync',
          });
        },
        async () => {
          await $schAsync(_udtThis);
        }
      ])
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0]
  ])

  const _hdrCs = [
    {
//      boxStlz: a(`dw/f fd/rsc mb/1`),
      cellCs: [
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `ユーザー名`,
            }),
          ]
        },
        {
          boxStlz: a(`f/2`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `メールアドレス`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/btn`),
          boxClds: [

          ]
        }
      ]
    }
  ];

  const _bdyCs = $_10rs?.map((__10rz: _ht.dz) => {
    return (
      {
        cellCs: [
          {
            boxStlz: a(`f/1`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${__10rz._pfx}`,
              }),
            ]
          },
          {
            boxStlz: a(`f/2`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${__10rz._10ra1100s}`,
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnCfmz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $_10r_key = __10rz._key;
                      pz.sPz.set({
                        steps: [1],
                        phs: 'd',
                      })
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
/*
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ) { // 初期化
      $_42z = {
        _42rz: {},
        _421s: [],
      };
      _udtThis();
    };
*/
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' ) { // 更新
      _hm.ectPrlAsync([
        _cmFTH.loadDzAsync2({
          tgt: '_10r.load_10zDzAsync',
          _10r_key: $_10r_key,
        })
        .then((__10z: _ht.dz) => {
          //_hm.l(`icv_42M10Rz 258: ${$_10r_key}, ${_hm.s(__10z)}`)
          $_10z = __10z;
        }),
        _cmFTH.loadDzAsync2({
          tgt: '_42r.load_42zDzAsync',
          _10r_key: $_10r_key,
          lwrz: {
            _421s: true,
          }
        })
        .then((__42z: _ht.dz) => {
          _hm.l(`icv_42M10Rz 258: ${$_10r_key}, ${_hm.s(__42z)}`)
          if (_hm.f(__42z._42rz)) {
            $_42z = __42z;
          }
          else {
            $_42z = {
              _42rz: {
                _42r_10r1k: $_10r_key,
              },
              _421s: [],
            };
          }
        }),
      ])
      .then(() => {
        _udtThis();
      });
    };
  }, [
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  const _hdrCs = [
    {
      cellCs: [
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `役割`,
            }),
          ]
        },
      ]
    }
  ];

  const _bdyCs = _cm.nfd($_42z._421s, false).map((__421z: _ht.dz) => {
    //_hm.l(`icv_41M10Rz 348: ${_hm.s(__411z)}`);
    return (
      {
        cellCs: [
          {
            boxStlz: a(`f/1 pr/1`),
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                  ls: $_41rs,
                  vle: __421z._421_41r1f,
                  onChg: (_dz: _ht.dz) => {
                    _cm.u(__421z, {
                      _421_41r1f: _dz.key,
                    })
                  }
                }
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn f/n`),
            boxClds: [

              _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDltz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      _cm.u(__421z, {
                        _dlt: 1,
                      });
                      _udtThis();
                    }
                  }            
                },
              })
              : undefined,

            ]
          }
        ]
      }
    );
  });

  if ( _hm.i(pz.sPz.crt.phs, ['c', 'u']) ) {
    _bdyCs.push(
      {
        cellCs: [
          {
            boxStlz: a(`f/n`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnAddz,                
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $_42z._421s.push({});
                      _udtThis();
                    }
                  }
                },
              }),

            ]
          }
        ]
      }
    );
  }

  return (
    _cr.c(GridC.N, {
      boxStlz: a(`dw/f dh/f pt/1`),
      lineCs: [
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `ユーザ名：`,
                    boxStlz: a(`dw/18`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: false,
                          vle: $_10z._10rz?._pfx,
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },

        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(TblC.N, {
                  abtz: icv.abtz.tblLinez,
                  hdrCz: {
                    abtz: icv.abtz.gridTblHdrz,
                    lineCs: _hdrCs,
                  },
                  bdyCz: {
                    abtz: icv.abtz.gridTblBdyz,
                    lineCs: _bdyCs
                  }
                })
              ]
            },
          ]
        },

      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  await _cmFTH.ugdDzAsync2({
    tgt: '_42r.ugd_42zDzAsync',
    _42z: $_42z,
  });
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sNgnz = useNgnz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onBackTop: () => {
          _sNgnz.setPageName('icvHomeM20Rz');
        },
        onUdtAsync: $upsAsync,
      },
    })  
  );

};
